import { z } from 'zod';
export const createListQuery = (options) => {
    const { sortable: { by: sortBy, default: sortDefault }, pageSize, filters, } = options;
    const sortOptions = sortBy.flatMap((option) => [option, `-${option}`]);
    const filtersSchema = filters;
    const filtersOutputSchema = filters instanceof z.ZodCodec ? filtersSchema.out : filtersSchema;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    const defaultSort = {
        by: sortDefault.replace(/^-/, ''),
        order: sortDefault.startsWith('-')
            ? 'desc'
            : 'asc',
    };
    const defaultPage = {
        limit: pageSize.default,
        page: 1,
    };
    const inputSchema = z
        .object({
        p: z
            .union([z.string().pipe(z.coerce.number()), z.number()])
            .pipe(z.number().int().min(1))
            .default(1),
        l: z
            .union([z.string().pipe(z.coerce.number()), z.number()])
            .pipe(z.number().int().min(1))
            .default(pageSize.default),
        s: z.enum(sortOptions).default(sortDefault),
    })
        .and(filtersSchema);
    const outputSchema = z.object({
        filters: filtersOutputSchema,
        pagination: z
            .object({
            limit: z.number(),
            page: z.number(),
        })
            .default(defaultPage),
        sort: z
            .object({
            by: z.string(),
            order: z.enum(['asc', 'desc']),
        })
            .default(defaultSort),
    });
    const codec = z.codec(inputSchema, outputSchema, {
        decode: (input) => {
            const { l: limitGiven, p: page, s: sort, ...filters } = input;
            return {
                filters,
                pagination: {
                    limit: Math.min(limitGiven, pageSize.max),
                    page,
                },
                sort: {
                    by: sort.replace(/^-/, ''),
                    order: sort.startsWith('-')
                        ? 'desc'
                        : 'asc',
                },
            };
        },
        encode: (output) => {
            const { pagination = defaultPage, sort = defaultSort, filters, } = output;
            return {
                ...filters,
                l: pagination.limit,
                p: pagination.page,
                s: (sort.order === 'desc'
                    ? `-${sort.by}`
                    : sort.by),
            };
        },
    });
    return {
        codec,
        encode: ({ filters = {}, pagination = defaultPage, sort = defaultSort, }) => ({
            ...filters,
            l: pagination.limit,
            p: pagination.page,
            s: (sort.order === 'desc'
                ? `-${sort.by}`
                : sort.by),
        }),
    };
};
